import type { PartnerTypes } from './types';

export const getPartnerDetails = (): PartnerTypes | null => {
  const data = localStorage.getItem('partnerDetails');
  return data ? (JSON.parse(data) as PartnerTypes) : null;
};

export const clearPartnerDetails = () => {
  localStorage.removeItem('partnerDetails');
};

export const setPartnerDetailsStorage = (details: PartnerTypes) => {
  localStorage.setItem('partnerDetails', JSON.stringify(details));
};